import { type FC } from 'react'
import { type ITextErrorProps, TextError } from 'shared/ui/Error/ui/TextError/TextError'
import { type ITooltipErrorProps, TooltipError } from 'shared/ui/Error/ui/TooltipError/TooltipError'

export type IErrorProps =
  | ({ type: 'text' } & ITextErrorProps)
  | ({ type: 'tooltip' } & ITooltipErrorProps)

export const Error: FC<IErrorProps> = ({ type, ...props }) => {
  if (type === 'text') {
    return <TextError {...props} />
  }
  if (type === 'tooltip') {
    return <TooltipError {...props} />
  }
  return null
}
